import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";

class MetricGeneratedKayak extends MetricBase {
    constructor() {
        super({
            field: "metric_generated",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.kayak.generated.chartName"),
            serieLabel: i18n.t("metrics.kayak.generated.serieLabel"),
            tooltip: i18n.t("metrics.kayak.generated.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricGeneratedKayak;
